module.exports = __webpack_public_path__ + "static/media/logo.5dd5ad51.png";